// src/components/Modals/NewFailureModal.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './ModalBase.css';
import { FaTimes } from 'react-icons/fa';
import Select from 'react-select';
import API_BASE_URL from '../../config';


/**
 * Логика сохранения:
 * 1. Создаём запись о поломке (POST /breake_problem/add_breake_problem).
 *    Коллектор в этот момент автоматически помечается как «сломанный».
 * 2. Если причина = «Профилактическая проверка», сразу же отправляем
 *    второй запрос (PUT /breake_problem/update_breake_problem/{id})
 *    и меняем status → «Отработано», closing_date → дата обнаружения.
 *    Так коллектор перестанет считаться сломанным.
 */
export default function NewFailureModal({ onClose, onSave }) {
  const [date, setDate] = useState('');
  const [collectorId, setCollectorId] = useState(null);
  const [reason, setReason] = useState('');
  const [comment, setComment] = useState('');
  const [materials, setMaterials] = useState('');
  const [masterName, setMasterName] = useState('');

  const [collectorsOptions, setCollectorsOptions] = useState([]);
  const [reasonsOptions, setReasonsOptions] = useState([]);

  useEffect(() => {
    // Загружаем причины поломок
    axios
      .get(`${API_BASE_URL}/breake_problem/summary/reasons`)
      .then(res => {
        const opts = res.data.map(r => ({ value: r.reason, label: r.reason }));
        setReasonsOptions(opts);
      })
      .catch(err => console.error('Ошибка загрузки причин поломок:', err));

    // Загружаем список коллекторов
    axios
      .get(`${API_BASE_URL}/collector/get_all_collectors`)
      .then(res => {
        const opts = res.data.map(c => ({ value: c.id, label: c.name }));
        setCollectorsOptions(opts);
      })
      .catch(err => console.error('Ошибка загрузки коллектора:', err));
  }, []);

  const handleSave = async () => {
    if (!date || !collectorId || !reason) {
      alert('Укажите дату, участок и причину!');
      return;
    }

    const isPreventive = reason === 'Профилактическая проверка';

    try {
      // 1. Добавляем поломку
      const addRes = await axios.post(`${API_BASE_URL}/breake_problem/add_breake_problem`, {
        collector_id: collectorId,
        date,
        reason,
        comments: comment,
        status: 'В процессе', // всегда «В процессе» при создании
        materials,
        master_name: masterName,
        closing_date: null
      });

      // Бэк должен вернуть ID созданной записи. Пробуем несколько вариантов поля.
      const newId = addRes.data?.id || addRes.data?.bp_id || addRes.data?.breake_problem_id;

      // 2. Если это ПП, сразу же закрываем поломку
      if (isPreventive && newId) {
        await axios.put(`${API_BASE_URL}/breake_problem/update_breake_problem/${newId}`, {
          status: 'Отработано',
          closing_date: date
        });
      }

      if (onSave) onSave();
      onClose();
    } catch (error) {
      console.error('Ошибка при добавлении/обновлении поломки:', error);
      alert('Не удалось сохранить поломку. Попробуйте ещё раз.');
    }
  };

  return (
    <div className="modal-overlay">
      <div className="modal-window pp">
        <button className="modal-close-btn" onClick={onClose}>
          <FaTimes />
        </button>
        <h2 className="modal-title">Добавление новой поломки</h2>

        <div className="modal-form">
          <label>Дата обнаружения поломки:</label>
          <input
            type="date"
            className="modal-input"
            value={date}
            onChange={e => setDate(e.target.value)}
          />

          <label>Участок (коллектор):</label>
          <Select
            className="modal-select"
            classNamePrefix="modal-select"
            options={collectorsOptions}
            value={collectorsOptions.find(o => o.value === collectorId) || null}
            onChange={opt => setCollectorId(opt?.value || null)}
            placeholder="Выберите участок"
            isSearchable
          />

          <label>Причина:</label>
          <Select
            className="modal-select"
            classNamePrefix="modal-select"
            options={reasonsOptions}
            value={reasonsOptions.find(o => o.value === reason) || null}
            onChange={opt => setReason(opt?.value || '')}
            placeholder="Выберите причину"
            isSearchable
          />

          <label>Материалы:</label>
          <input
            type="text"
            className="modal-input"
            value={materials}
            onChange={e => setMaterials(e.target.value)}
            placeholder="Введите материалы"
          />

          <label>Исполнитель:</label>
          <input
            type="text"
            className="modal-input"
            value={masterName}
            onChange={e => setMasterName(e.target.value)}
            placeholder="Введите имя исполнителя"
          />

          <label>Комментарий:</label>
          <textarea
            className="modal-input"
            rows={4}
            value={comment}
            onChange={e => setComment(e.target.value)}
          />
        </div>

        <div className="modal-actions">
          <button className="modal-button cancel" onClick={onClose}>
            Отменить
          </button>
          <button className="modal-button save" onClick={handleSave}>
            Сохранить
          </button>
        </div>
      </div>
    </div>
  );
}